<template>
	<div id="app">
		<headers></headers>
		<div class="loginform">
			<div class="left">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
					<span class="title">账号登录</span>
					<el-form-item prop="name">
						<el-input v-model="ruleForm.name" placeholder="登录账号"></el-input>
					</el-form-item>
					<el-form-item v-if="is_sms_login">
						<el-input v-model="ruleForm.password" type="password" placeholder="登录密码"></el-input>
					</el-form-item>
          <el-form-item v-else>
            <div style="display: inline-block;width: 69%;"><el-input v-model="ruleForm.smscode" type="string" placeholder="请输入验证码"></el-input></div>
            <div class="smsbtn" @click="getsms()">{{smstext}}</div>
          </el-form-item>
          <el-form-item>
            <div class="loginbtn" @click="login()">登录</div>
          </el-form-item>
          <!-- <el-form-item>
            <div class="qqlogin"><i class="qqicon"></i><span>手机登录</span></div>
            <div class="wxlogin"><i class="weixinicon"></i><span>微信登录</span></div>
          </el-form-item> -->
          <el-form-item>
            <div class="smslogin" v-if="is_sms_login" @click="is_sms_login=false">验证码登录</div>
            <div class="smslogin" v-else @click="is_sms_login=true">密码登录</div>
          </el-form-item>
				</el-form>
			</div>
		</div>
    <footers></footers>
	</div>
</template>

<script>
	import headers from '../../components/headers.vue';
  import footers from '../../components/footers.vue';
  import { sendsms,mobilelogin,updateHeader,phonenumberlogin } from '../../request/api';

	export default {
		name: 'app',
		components: {
			headers,
      footers
		},
		data() {
			return {
				ruleForm: {
					name: '',
					region: '',
          password: ''
				},
				rules: {
					name: [{
						required: true,
						message: '请输入登录账号',
						trigger: 'blur'
					}],
					region: [{
						required: true,
						message: '请输入登录密码',
						trigger: 'blur'
					}]
				},
        smstext:'获取验证码',
				codeurl:require('../../assets/code.png'),
        isclick:true,
        is_sms_login:false
			}
		},
		methods: {
      // 登录方法
			login() {
        if(this.is_sms_login){
          phonenumberlogin({'account':this.ruleForm.name,'password':this.ruleForm.password}).then(res=>{
              if(res.code){
                localStorage.setItem('userinfo',JSON.stringify(res.data.userinfo))
                localStorage.setItem('token',res.data.userinfo.token)
                updateHeader('token',res.data.userinfo.token)
                this.$router.push({name:'courseware'})
              }else{
                this.$message.error(res.msg);
              }
          })
        }else{
          mobilelogin({'mobile':this.ruleForm.name,'captcha':this.ruleForm.smscode}).then(res=>{
              if(res.code){
                localStorage.setItem('userinfo',JSON.stringify(res.data.userinfo))
                localStorage.setItem('token',res.data.userinfo.token)
                updateHeader('token',res.data.userinfo.token)
                this.$router.push({name:'courseware'})
              }else{
                this.$message.error(res.msg);
              }
          })
        }
			},
      // 发送验证码
      getsms(){
        sendsms({'mobile':this.ruleForm.name,'event':'mobilelogin'}).then(res=>{
          //判断是否发送成功
          if(res.code){
            //判断用户是否点击发送过了
            if(this.isclick){
              this.isclick=false
              //计时器，设置60秒后允许用户再次点击
              let time=60
              let self=this
              this.$message.success("获取成功")
              self.smstext=time+'s后重新获取';
              let interval=setInterval(()=>{
                console.log("10000",time)
                time--
                if(time>=0){
                  self.smstext=time+'s后重新获取';
                }else{
                  self.isclick=true
                  self.smstext='重新获取';
                }
              },1000)
            }else{
              this.$message.error(this.smstext);
            }
          }else{
              this.$message.error(res.msg);
          }
        })
      }
		}
	}
</script>

<style>
  html{height: 100%;}
	body {
		padding: 0px;
		margin: 0px;
    height: 100%;
	}



	.loginform {
		width: 700px;
		margin: 0 auto;
		overflow: hidden;
		margin-top: 187px;
    margin-bottom: 60px;
    background: #FFFFFF;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    padding-top: 36px;
    text-align: center;
	}

	.loginform .left {
		width: 700px;
		height: auto;
	}

	.el-form {
		width: 600px;
		align-self: center;
		margin: 0 auto;
	}

	.loginform .title {
		font-weight: 400;
		font-size: 25.875px;
		line-height: 36px;
		color: #0A1633;
    margin-bottom: 18px;
    display: block;
	}

	.loginform .right {
		float: left;
		width: 338.5px;
		height: auto;
		display: flex;
	}
	.loginform .right div{
		margin: 0 auto;
		align-self: center;
	}

	.el-form-item__content {
		margin-left: 0px !important;
	}

	.loginform .left .el-input__inner{
	  height: 58px !important;
    line-height: 58px !important;
	  background: #FAFAFC;
	  box-shadow: 0px 5px 12px 0px rgba(0,0,0,0.05);
	  border-radius: 12px 12px 12px 12px;
	  opacity: 1;
	  border: 2px solid #E3E9ED;
	}

	.subtitle{font-size: 20px;font-weight: 600;color: #526075;line-height: 21px;}

	.reload{
		font-size: 20px;
		font-weight: 400;
		color: #526075;
		line-height: 21px;
	}

  .el-form-item{

  }

  .qqlogin{
    width: calc((100% - 12px) / 2);
    height: 64px;
    line-height: 64px;
    background: #30A5DD;
    border-radius: 500px 500px 500px 500px;
    opacity: 1;
    display: inline-block;
    font-size: 24px;
    color: #FDFDFD;
    float: left;
    cursor:pointer
  }
  .wxlogin span{
    display: inline-block;
    height: 30px;
    line-height: 30px;
    background: url('../../assets/weixin.png') no-repeat;
    text-indent: 32px;
  }

  .wxlogin{
    width: calc((100% - 12px) / 2);
    height: 64px;
    line-height: 64px;
    background: #28C445;
    border-radius: 500px 500px 500px 500px;
    opacity: 1;
    display: inline-block;
    font-size: 24px;
    color: #FDFDFD;
    float: right;
    cursor:pointer
  }
  .qqlogin span{
    display: inline-block;
    height: 30px;
    line-height: 30px;
    background: url('../../assets/qq.png') no-repeat;
    text-indent: 32px;
  }

  .smslogin{
    width: 100%;
    height: 64px;
    line-height: 64px;
    background: #EEF5EF;
    border-radius: 500px 500px 500px 500px;
    cursor:pointer
  }

  .loginbtn{
    width: 100%;
    height: 60px;
    line-height: 60px;
    background: #22AC38;
    border-radius: 375px;
    color: #FDFDFD;
    font-weight: 700;
    font-size: 21px;
    cursor:pointer;
  }

  /* .qqicon{
    width: 30px;
    height: 30px;
    background: url('../../assets/qq.png');
    display: inline-block;
  }

  .weixinicon{
    width: 30px;
    height: 30px;
    background: url('../../assets/weixin.png');
    display: inline-block;
  } */
  .smsbtn{
    display: inline-block;
    width: 25%;
    margin-left: 4%;
    height: 58px;
    line-height: 58px;

    background: #FAFAFC;
    /* Grayscale/Grayscale 30 */

    border: 1.125px solid #E3E9ED;
    box-shadow: 0px 3.375px 9px rgba(0, 0, 0, 0.05);
    border-radius: 9px;
    cursor:pointer;
  }
  .el-input{
    width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/home.vue